import { SupplierApiModel } from '@/core/models/api/supplier-api-model.model';

export interface ProviderState {
    items: SupplierApiModel[];
    loaded: boolean;
    loading: boolean;
    error: any;
}

export const initialProviderState: ProviderState = {
    items: [],
    loaded: false,
    loading: false,
    error: null,
};
